import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css'; // Đảm bảo đã import Bootstrap
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Đảm bảo đã import Bootstrap
import './NavBar.css'; // Import CSS

const NavBar = () => {
  return (
    <nav className="navbar navbar-expand-lg">
      <div className="container">
        <Link className="navbar-brand" to="/home">
          <img src={'/logo192.png'} alt="logo" width="100" height="60" className="d-inline-block align-text-top" style={{ objectFit: 'cover' }} />
        </Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/home">Trang chủ</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/knowledge">Kiến thức</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/products">Sản phẩm</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact">Liên hệ</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
